import React, { Component } from 'react';
import { translate } from 'react-i18next';

class ReferralForm extends Component {

  isSubmitdisabled = () => {
    return this.props.noReferral ||
      (
        this.props.referralCompany
        && this.props.referralEmail
        && this.props.referralName
        && this.props.referralPhone
      );
  }

  render() {
    const { t } = this.props;
    return(
      <form method="post" onSubmit={this.props.handleReferralForm}>
        <fieldset>
          <div className="panel panel-default">
            <div className="panel-heading">
              <h4 className="panel-title">
                ¿Alguien que conoces necesita una oficina?<b>Coloca los datos de tu referido aquí </b> y recibe una sorpresa
              </h4>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="custom-csmr">
                  <div className="form-group">
                    <div className="checkbox">
                      <label>
                        <input
                          onChange={this.props.handleNoReferral}
                          type="checkbox" checked={this.props.noReferral}/>
                        {t('guest.survey.no_referral')}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="name">
                      {t('guest.survey.label_name')}
                    </label>
                    <input
                      className="form-control"
                      disabled={this.props.noReferral}
                      id="name"
                      onChange={this.props.handleReferralName}
                      placeholder={t('guest.survey.holder_name')}
                      required={!this.props.noReferral}
                      type="text"
                      value={this.props.referralName} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="company">
                      {t('guest.survey.label_company')}
                    </label>
                    <input
                      className="form-control"
                      disabled={this.props.noReferral}
                      id="company"
                      onChange={this.props.handleReferralCompany}
                      placeholder={t('guest.survey.holder_company')}
                      required={!this.props.noReferral}
                      type="text"
                      value={this.props.referralCompany} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="email">
                      {t('guest.survey.label_email')}
                    </label>
                    <input
                      className="form-control"
                      disabled={this.props.noReferral}
                      id="email"
                      onChange={this.props.handleReferralEmail}
                      placeholder={t('guest.survey.holder_email')}
                      required={!this.props.noReferral}
                      type="email"
                      value={this.props.referralEmail} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="phone">
                      {t('guest.survey.label_phone')}
                    </label>
                    <input
                      className="form-control"
                      disabled={this.props.noReferral}
                      id="phone"
                      onChange={this.props.handleReferralPhone}
                      placeholder={t('guest.survey.holder_phone')}
                      required={!this.props.noReferral}
                      type="tel"
                      value={this.props.referralPhone} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="comments">
                      {t('guest.survey.label_comments')}
                    </label>
                    <textarea
                      className="form-control"
                      disabled={this.props.noReferral}
                      id="comments"
                      onChange={this.props.handleReferralComments}
                      rows="3"
                      value={this.props.referralComments} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="alert alert-info">
            {t('guest.survey.aknowledgement')}
          </div>
          <div className="form-group text-center">
            <button
              className="btn btn-primary"
              disabled={!this.isSubmitdisabled()}
              type="submit">
              {t('guest.survey.btn_submit')}
            </button>
          </div>
        </fieldset>
      </form>
    );
  }
}

export default translate('common')(ReferralForm);



// WEBPACK FOOTER //
// ./src/guest/survey/ReferralForm.js